export const FFT_TWF_CHARTS_KEYS = {
  twfacc: 'accelerationTwf',
  fftacc: 'accelerationFft',
  twfvel: 'velocityTwf',
  fftvel: 'velocityFft',
};
